module.exports = __webpack_public_path__ + "img/mD-badge2-light.7e239d06.png";